import type { JpAddressValue } from '../../components/JpAddressInput';

export type EmployeeSectionStep =
  | 'fullName'
  | 'fullNameKana'
  | 'dob'
  | 'myNumber'
  | 'address'
  | 'headOfHousehold'
  | 'headName'
  | 'headRelationship'
  | 'employeeEstimatedIncome'
  | 'multipleEmployers'
  | 'multipleEmployersNotice';

export type YesNo = 'yes' | 'no';

export type HeadRelationship =
  | 'spouse'
  | 'child'
  | 'mother'
  | 'father'
  | 'grandparent'
  | 'sibling';

export type ProfileSnapshot = {
  familyName: string;
  firstName: string;
  middleName: string;
  familyNameKana: string;
  firstNameKana: string;
  middleNameKana: string;
  dateOfBirth: string;
  myNumber: string;
  address: JpAddressValue;
};

export type DeclarationSnapshot = {
  isHeadOfHousehold: YesNo | '';
  headOfHouseholdName: string;
  relationshipToHead: HeadRelationship | '';
  multipleEmployers: YesNo | '';
  employeeEstimatedIncome: string;
};

export const EMPLOYEE_SECTION_STEP_ORDER: EmployeeSectionStep[] = [
  'fullName',
  'fullNameKana',
  'dob',
  'myNumber',
  'address',
  'headOfHousehold',
  'headName',
  'headRelationship',
  'employeeEstimatedIncome',
  'multipleEmployers',
  'multipleEmployersNotice',
];
